import { stringify } from 'qs';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type QueryParams = Record<string, any>;
export type RestoredSearchFilter = Record<
  string,
  | Record<
      string,
      | {
          qs?: string;
          scrollY?: number;
        }
      | undefined
    >
  | undefined
>;

export const SESSION_KEY = {
  /** 레저 PLP/SRP 세션 스토리지 키 */
  leisure: 'leisureSearchFilter',
  /** 국내숙소 PLP/SRP 세션 스토리지 키 */
  local: 'localSearchFilter',
  /** 버티컬 검색결과 세션 스토리지 키 */
  vertical: 'verticalSearchFilter',
  /** 위치 세션 스토리지 키 */
  localLocation: 'localLocation',
};

export const getRestoredSearchFilterStorage = ({ sessionKey }: { sessionKey: string }) => {
  const restoredSearchFilter: RestoredSearchFilter = JSON.parse(sessionStorage.getItem(sessionKey) || '{}');
  return restoredSearchFilter;
};

export const updateFilterStorage = ({
  query,
  scrollY,
  sessionKey,
  searchType,
  sessionPageKey,
}: {
  query: QueryParams;
  scrollY: number;
  sessionKey: string;
  searchType: string | undefined;
  sessionPageKey?: string | undefined;
}) => {
  const { pageKey } = sessionPageKey ? { pageKey: sessionPageKey } : query;
  const shortcut = searchType || 'all';

  const restoredSearchFilter = getRestoredSearchFilterStorage({
    sessionKey,
  });

  const searchFilter: RestoredSearchFilter = {
    ...restoredSearchFilter,
    [pageKey]: {
      ...restoredSearchFilter[pageKey],
      [shortcut]: {
        qs: stringify({
          ...query,
        }),
        scrollY,
      },
    },
  };

  sessionStorage.setItem(sessionKey, JSON.stringify(searchFilter));
};

export const clearCurrentFilterStorage = ({ pageKey, sessionKey }: { pageKey: string; sessionKey: string }) => {
  const restoredSearchFilter = getRestoredSearchFilterStorage({
    sessionKey,
  });

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { [pageKey]: _, ...searchFilter } = restoredSearchFilter;

  sessionStorage.setItem(sessionKey, JSON.stringify(searchFilter));
};

const MAX_ENTRIES = 10; // 저장할 최대 pageKey 개수

export const cleanStorageSearchFilter = (key: string) => {
  if (MAX_ENTRIES <= 0) return;

  const raw = sessionStorage.getItem(key);
  if (!raw) return;

  try {
    const parsed = JSON.parse(raw) as Record<string, unknown>;
    const keys = Object.keys(parsed).sort(); // pageKey는 타임스탬프라서 sort로 오래된 순 정렬됨

    if (keys.length > MAX_ENTRIES) {
      const keysToRemove = keys.slice(0, keys.length - MAX_ENTRIES);
      const filtered = Object.fromEntries(Object.entries(parsed).filter(([key]) => !keysToRemove.includes(key)));

      sessionStorage.setItem(key, JSON.stringify(filtered));
    }
  } catch (e) {
    console.warn('Invalid SearchFilter data', e);
  }
};
